import { defineStore } from "pinia";

import { markRaw } from "vue"

import API from "../api/index";

export const useInteractiveStore = defineStore("interactive", {
    
    state: () => ({
       
       side_bar_css: null,
       
       container_css: null,

       sub_container_css: null,

       open_hamburger_css: null,

       close_hamburger_css: null,

       backend_message: '',

       display_success_alert: false,

       display_error_alert: false,

       display_loading_overlay: false,

       query: '',

       // ── Modal ────────────────────────────────────────
       modal_is_open:    false,
       modal_title:      '',
       modal_component:  null,
       modal_props:      {},

       // ── Action Modal ────────────────────────────────────────
       display_action_modal: false,
       action_modal_type: 'info',
       action_modal_message: '',
       action_modal_title: '',
       confirmCallback: null,

    }),


    actions: {

        Open_Sidebar() {

           this.side_bar_css = {
               "display":"block"
            }

           this.container_css = {
                "height": "100vmax", 
                "width": "calc(100% + 250px)",
                "overflow-x": "auto",
                "overflow-y": "hidden"
            };

           this.sub_container_css = {
                "transition": "0.5s",
                "width": "calc(100% - 250px)"
            };
          
            this.open_hamburger_css = {"display": "none"}
          
            this.close_hamburger_css = {"display": "inline-block"}

        },


        Close_Sidebar() {

            this.side_bar_css = {"display":"none"}
        
            this.container_css = {
              "height": "auto", 
              "width": "100%",
            };
        
            this.sub_container_css = {
              "transition": "0s",
              "width": "100%",
            };
        
            this.close_hamburger_css = {"display": "none"}
        
            this.open_hamburger_css = {"display": "inline-block"}
        
        },

        display_success_alert_box() {

            this.display_success_alert = true

            setTimeout(() => {

                this.display_success_alert = false

            }, 6000)

        },

         
        display_error_alert_box() {

            this.display_error_alert = true

            setTimeout(() => {

                this.display_error_alert = false

            }, 6000)

        },

        toggle_loading_overlay(state) {

            this.display_loading_overlay = state

        },

        clearQuery() {

            this.query = ''

        },

        // ── Modal ────────────────────────────────────────

        open_modal(title, component, props = {}) {

            this.modal_title     = title
            this.modal_component = markRaw(component)
            this.modal_props     = props
            this.modal_is_open   = true

        },

        close_modal() {

            this.modal_is_open   = false
            this.modal_title     = ''
            this.modal_component = null
            this.modal_props     = {}

        },

        // ── Action Modal ────────────────────────────────────────

        open_action_modal(payload) {

            this.action_modal_type = payload.type || 'info'
          
            this.action_modal_title = payload.title || ''
          
            this.action_modal_message = payload.message || ''
          
            this.display_action_modal = true
          
            return new Promise((resolve) => {
          
              this.confirmCallback = () => {
                resolve(true)
              }
          
              this.cancelCallback = () => {
                resolve(false)
              }
          
            })
          
          },

        close_action_modal() {

            this.display_action_modal = false
            
            this.confirmCallback = null
            
            this.cancelCallback = null
        
        },
      
      
        confirmAction() {
      
            if (this.confirmCallback) {
              
                this.confirmCallback()
            }
      
            this.close_action_modal()
          
        },

         cancelAction() {

            if (this.cancelCallback) {
              this.cancelCallback()
            }
          
            this.close_action_modal()
          
          },


    }
})